export default {
	TIMER: 1,
	COLLABORATE: 2,
}
